module.exports = __webpack_public_path__ + "img/globalCommbook.2aeda35b.svg";